import { Box } from '@chakra-ui/react'
import { BrandBar } from '../../components/BrandBar'
import { TitleHeader } from '../../components/TitleHeader'
import { EmailLoginForm } from '../components/EmailLoginForm'

export const Login = () => {
  return (
    <Box bg="bg.secondary" minH="100vh" display="flex" justifyContent="center">
      <Box w="100%" maxW="500px">
        <BrandBar />
        <TitleHeader title="ログイン" />
        <Box pt="24px" px="31px">
          <EmailLoginForm />
        </Box>
      </Box>
    </Box>
  )
}
